import React, { useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import QuestionItem from '../../../Admin/PreboardingConfiguration/HiringExperienceConfiguration/QuestionItem';
import FeedbackBox from '../../../Admin/PreboardingConfiguration/HiringExperienceConfiguration/FeedbackBox';
import { Question } from '../../../Admin/PreboardingConfiguration/HiringExperienceConfiguration/HiringExperienceConfiguration';
import { getHiringExperienceQuestions } from '../../../Admin/PreboardingConfiguration/preboardingConfigurationApi';
import { useNavigate, useParams } from 'react-router-dom';
import { theme } from '../../../../../theme';
import { useSnackbar } from '../../../../../Context/SnackbarContext';
import { useCandidatePreboarding } from '../CandidatePreboardingContext';
import { saveHiringExperience } from '../candidatePreboardingApi';
import FeedbackImage from "../../../../../Assets/AuthBackGround/FeedbackImage.png"

const HiringExperience: React.FC = () => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [feedback, setFeedback] = useState("");
  const { tenant } = useParams<{ tenant: string }>();
  const [loading, setLoading] = useState(true)
  const { showSnackbar } = useSnackbar();
  const isCandidate = !!sessionStorage.getItem("candidate_session");
  const { candidateData } = useCandidatePreboarding();
  const navigate = useNavigate();
  const [isCandidateSubmittedHiringExperience, setIsCandidateSubmittedHiringExperience] = useState(false);

  const handleAnswerChange = (id: number, answer: string) => {
    setQuestions(prev =>
      prev.map(q => (q.QuestionNum === id ? { ...q, Answer: answer } : q))
    );
  };

  const fetchQuestions = async () => {
    const payLoad = {
      "MapID": candidateData?.mapID,
    }
    try {
      const result = await getHiringExperienceQuestions(tenant, payLoad, isCandidate)
      if (result) {
        setFeedback(result.Feedback || "")
        setQuestions(result.Questions)
        // Set to true if all answers are NOT empty
        setIsCandidateSubmittedHiringExperience(
          result.Questions.every((q: Question) => q.Answer.trim() !== "")
        );
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  }

  useEffect(() => {
    if (candidateData?.mapID) fetchQuestions()
  }, [tenant, candidateData?.mapID])

  const handleSubmit = async () => {
    if (questions.some(q => !q.Answer)) {
      showSnackbar("Please answer all questions and provide feedback before submitting.", "error");
      return;
    }

    if (feedback.trim() && feedback.trim().length > 500) {
      showSnackbar("Feedback should not exceed 500 characters.", "error");
      return;
    }

    const payLoad = {
      MapID: candidateData?.mapID,
      Responses: questions.map((q) => { return { QuestionNum: q.QuestionNum, Answer: q.Answer } }),
      Feedback: feedback,
      RecruiterName: candidateData?.recruiterName,
      RecruiterEmail: candidateData?.recruiterEmail
    }

    try {
      const response = await saveHiringExperience(tenant, payLoad, isCandidate)
      if (response) {
        showSnackbar(response.Message, response.Status ? "success" : "error")
        if (response.Status) {
          navigate(`/${tenant}/ThankYou`, {
            state: { message: "Thank you for submitting your valuable feedback." }
          })
          sessionStorage.removeItem("candidate_session");
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleCancel = () => {
    //reset all answers and feedback
    setQuestions(prev => prev.map(q => ({ ...q, answer: "" })));
    setFeedback("");
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', mt: '2vw' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (!isCandidate && !isCandidateSubmittedHiringExperience) {
    return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        textAlign: 'center',
        width: '100%',
        gap: 2,
      }}>
        {/* <SentimentDissatisfiedOutlinedIcon sx={{ fontSize: 70, color: theme.palette.error.main, mb: 2 }} />
         */}
        <Box
          component="img"
          src={FeedbackImage}
          alt="Feedback"
          sx={{ width: "13vw", height: "auto",mb:0.5}}
        />

        <Typography variant="h4" color={theme.palette.primary.main} >
          Oops! No Feedback Yet
        </Typography>
        <Typography variant="h6" color="textSecondary" >
          The candidate has not filled out the hiring experience feedback yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box width={"100%"}>

      <Typography variant='h5' mt={2}>
        Hiring Experience
      </Typography>
      <Typography variant='body1' color="textSecondary" mt={1}>
        Please share your feedback on our hiring process. Let us know what worked well and where we can improve.
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'start' }}>
        <Box flex={2}>
          {questions.map((q, index) => (
            <QuestionItem
              key={q.QuestionNum}
              index={index + 1}
              question={q}
              onAnswerChange={handleAnswerChange}
            />
          ))}
        </Box>
        <FeedbackBox feedback={feedback} setFeedback={setFeedback} />
      </Box>

      {
        isCandidate && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '1vw',
              mt: '2vw',
              mb: '1vw'
            }}

          >
            <Button
              variant="outlined"
              onClick={handleCancel}
              sx={{ borderColor: theme.palette.primary.main, color: theme.palette.primary.main }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ bgcolor: theme.palette.primary.main }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
        )
      }

    </Box>
  );
}

export default HiringExperience